<template>
    <div>
        <portal-target name="dropdown" slim />
        <div class="md:flex md:flex-col">
            <div class="md:h-screen md:flex md:flex-col">
                <div class="md:flex md:flex-shrink-0">
                    <div class="bg-black md:flex-shrink-0 md:w-56 px-2 py-4 flex items-center justify-between md:justify-center">
                        <inertia-link class="mt-1" href="/">
                        <div class="text-white">Registro de Aspirantes</div>
                        </inertia-link>
                        <dropdown class="md:hidden" placement="bottom-end">
                        <svg class="fill-white w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
                        <div slot="dropdown" class="mt-2 px-8 py-4 shadow-lg bg-indigo-900 rounded">
                            <main-menu />
                        </div>
                        </dropdown>
                    </div>
                    <div class="bg-red-aspirante border-b w-full p-4 md:py-0 md:px-12 text-sm md:text-md flex justify-between items-center">
                        <div><logo style="width: 40% !important;"/></div>
                        <dropdown class="mt-1" placement="bottom-end">
                        <div class="flex items-center cursor-pointer select-none group">
                            <div class="text-white group-hover:text-gray-800 focus:text-gray-50 mr-1 whitespace-nowrap">
                            <span>{{ $page.props.auth.user.first_name }}</span>
                            <span class="hidden md:inline">{{ $page.props.auth.user.last_name }}</span>
                            </div>
                            <icon class="w-5 h-5 fill-white group-hover:fill-gray-800 focus:fill-gray-500" name="cheveron-down" />
                        </div>
                        <div slot="dropdown" class="mt-2 py-2 shadow-xl bg-white rounded text-sm">
                            <!-- <inertia-link class="block px-6 py-2 hover:bg-indigo-500 hover:text-white" :href="route('users.edit', $page.props.auth.user.id)">Mi Perfil</inertia-link> -->
                            <!-- <inertia-link class="block px-6 py-2 hover:bg-indigo-500 hover:text-white" :href="route('users')">Administrar usuarios</inertia-link>-->
                            <inertia-link class="block px-6 py-2 hover:bg-indigo-500 hover:text-white w-full text-left" :href="route('logout')" method="post" as="button">Salir</inertia-link>
                        </div>
                        </dropdown>
                    </div>
                </div>
                <div class="md:flex md:flex-grow md:overflow-hidden">
                    <!-- <main-menu v-if="is_admin" class="hidden md:block bg-menu flex-shrink-0 w-56 p-12 overflow-y-auto" /> -->
                    <div class="md:flex-1 px-4 py-8 md:p-12 md:overflow-y-auto" scroll-region>
                        <flash-messages />
                        <slot />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Logo,
    MainMenu,
  },
  data() {
        return {
            is_admin: false
        }
  },
  mounted(){
    //   console.log(this.$page.props.auth.user)
      if (this.$page.props.auth.user.is_admin) {
          this.is_admin = true;
       }

  }
}
</script>
